import React, { useEffect } from 'react';
import { useNavigate, Outlet } from 'react-router-dom';
import {jwtDecode} from 'jwt-decode'; // Correct import
import ResponsiveAppBar from './navbar';

const Dashboard = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (token) {
      try {
        const user = jwtDecode(token);
        // Perform additional checks on the decoded user if needed
        if (!user) {
          localStorage.removeItem('token');
          navigate('/login');
        }
      } catch (error) {
        console.error('Token decoding failed', error);
        localStorage.removeItem('token');
        navigate('/login');
      }
    } else {
      navigate('/login');
    }
  }, [navigate]);

  return (
    <div>
      <ResponsiveAppBar />
        <main>
          <Outlet /> {/* This will render nested route components */}
        </main>
    </div>
  );
};

export default Dashboard;
